import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { CustomMessages } from '@shared';
import { SidebarComponent } from 'app/theme/admin-layout/sidebar/sidebar.component';
import { AirMasterService } from 'app/service/air-master.service';
import { AuditProgramAIRItemDocumentDTO } from 'app/model/audit-program-air-item-document-dto';
import { HttpClient } from '@angular/common/http';
import { ManageAuditProgarmService } from 'app/service/manage-audit-progarm-service';
import { CommonService } from 'app/service/common.service';
import { ComboPopulation } from 'app/model/combo-population';
import { AuditProgramAIRDTO } from 'app/model/audit-program-air-dto';

@Component({
  selector: 'app-searchair',
  templateUrl: './searchair.component.html',
  styleUrls: ['./searchair.component.scss']
})
export class SearchairComponent implements OnInit {

  parsedJson: any;
  errorMsgId: number;

  items: ComboPopulation[] = [];
  airAuditorActionComboList: ComboPopulation[] = [];
  copyAirAuditorActionComboList: ComboPopulation[] = [];
  airAuditeeActionComboList: ComboPopulation[] = [];
  copyAirAuditeeActionComboList: ComboPopulation[] = [];

  isAirAuditorActionAllChecked: boolean = false;
  isAirAuditeeActionAllChecked: boolean = false;

  showAirAuditorActionAllOption: boolean = true;
  showAirAuditeeActionAllOption: boolean = true;

  searchAirAuditorAction: string = '';
  searchAirAuditeeAction: string;

  auditProgramAIRDTO = new AuditProgramAIRDTO();


  @Output() closePanelair: EventEmitter<boolean> = new EventEmitter();
  @Output() closePanelAir: EventEmitter<boolean> = new EventEmitter();
  @Output() filterValues = new EventEmitter<AuditProgramAIRDTO>();

  constructor(private customMessage: CustomMessages, private sidebarComponent: SidebarComponent,
    private commonService: CommonService,) { }

  ngOnInit() {
    this.getAIRAuditorActionList();
    this.getAIRAuditeeActionList();
  }

  closed() {
    this.closePanelair.emit(false);
  }

  getAIRAuditorActionList() {
    this.sidebarComponent.showHideLoader(true);
    this.commonService.getAIRAuditorActionList()
      .subscribe(data => {
        this.parsedJson = JSON.parse(JSON.stringify(data));
        this.airAuditorActionComboList = this.parsedJson;
        this.copyAirAuditorActionComboList = this.airAuditorActionComboList;
        this.sidebarComponent.showHideLoader(false);
      }, (error) => {
        this.sidebarComponent.showHideLoader(false);
        this.customMessage.showErrorMessage(error.error.msgId, error.error.message);
      });
  }


  getAIRAuditeeActionList() {
    this.sidebarComponent.showHideLoader(true);
    this.commonService.getAIRAuditeeActionList()
      .subscribe(data => {
        this.parsedJson = JSON.parse(JSON.stringify(data));
        this.airAuditeeActionComboList = this.parsedJson;
        this.copyAirAuditeeActionComboList = this.airAuditeeActionComboList;
        this.sidebarComponent.showHideLoader(false);
      }, (error) => {
        this.sidebarComponent.showHideLoader(false);
        this.customMessage.showErrorMessage(error.error.msgId, error.error.message);
      });
  }

  toggleSelectAll(listType) {
    if (listType === 'airAuditorActionList' && this.isAirAuditorActionAllChecked) {
      this.airAuditorActionComboList.map((o: any, index) => {
        o.checked = true;
      })
    } else if (listType === 'airAuditeeActionList' && this.isAirAuditeeActionAllChecked) {
      this.airAuditeeActionComboList.map((o: any, index) => {
        o.checked = true;
      })
    } else if (listType === 'airAuditorActionList' && !this.isAirAuditorActionAllChecked) {
      this.airAuditorActionComboList.map((o: any, index) => {
        o.checked = false;
      })
    } else if (listType === 'airAuditeeActionList' && !this.isAirAuditeeActionAllChecked) {
      this.airAuditeeActionComboList.map((o: any, index) => {
        o.checked = false;
      })
    }
  }

  filterAirAuditorActionList(text) {
    this.airAuditorActionComboList = this.copyAirAuditorActionComboList;
    this.items = this.airAuditorActionComboList;
    if (text === "") {
      this.airAuditorActionComboList = this.copyAirAuditorActionComboList;
      this.showAirAuditorActionAllOption = true;
    }
    if (text != '') {
      this.items = this.airAuditorActionComboList.filter(s => s.name.toLowerCase().includes(text.toLowerCase()));
      this.assignAirAuditorActionCopy();
      this.showAirAuditorActionAllOption = false;
    }
  }

  assignAirAuditorActionCopy() {
    this.airAuditorActionComboList = Object.assign([], this.items);
  }


  filterAirAuditeeActionList(text) {
    this.airAuditeeActionComboList = this.copyAirAuditeeActionComboList;
    this.items = this.airAuditeeActionComboList;
    if (text === "") {
      this.airAuditeeActionComboList = this.copyAirAuditeeActionComboList;
      this.showAirAuditeeActionAllOption = true;
    }
    if (text != '') {
      this.items = this.airAuditeeActionComboList.filter(s => s.name.toLowerCase().includes(text.toLowerCase()));
      this.assignAirAuditeeActionCopy();
      this.showAirAuditeeActionAllOption = false;
    }
  }

  assignAirAuditeeActionCopy() {
    this.airAuditeeActionComboList = Object.assign([], this.items);
  }


  resetFilter() {
    this.airAuditorActionComboList.map((o: any, index) => {
      o.checked = false;
    })

    this.airAuditeeActionComboList.map((o: any, index) => {
      o.checked = false;
    })

    this.isAirAuditorActionAllChecked = false;
    this.isAirAuditeeActionAllChecked = false;

    this.searchAirAuditorAction = "";
    this.searchAirAuditeeAction = "";

    this.airAuditorActionComboList = this.copyAirAuditorActionComboList;
    this.airAuditeeActionComboList = this.copyAirAuditeeActionComboList;

    this.showAirAuditorActionAllOption = true;
    this.showAirAuditeeActionAllOption = true;

    this.auditProgramAIRDTO.auditorAction = '';
    this.auditProgramAIRDTO.auditeeAction = '';

    this.filterValues.emit(this.auditProgramAIRDTO);
    this.closed();

  }

  applyFilter() {
    let selectedAirAuditorAction: any;
    let selectedAirAuditeeAction: any;

    selectedAirAuditorAction = this.airAuditorActionComboList.filter(o => {
      return o.checked;
    }).map(p => {
      return p.id
    }).join(',');

    selectedAirAuditeeAction = this.airAuditeeActionComboList.filter(o => {
      return o.checked;
    }).map(p => {
      return p.id
    }).join(',');


    this.auditProgramAIRDTO.auditorAction = selectedAirAuditorAction;
    this.auditProgramAIRDTO.auditeeAction = selectedAirAuditeeAction;

    this.filterValues.emit(this.auditProgramAIRDTO);
    this.closed();

  }

}